import { render, staticRenderFns } from "./form5_1c.vue?vue&type=template&id=494c76d0&scoped=true"
import script from "./form5_1c.vue?vue&type=script&lang=js"
export * from "./form5_1c.vue?vue&type=script&lang=js"
import style0 from "./form5_1c.vue?vue&type=style&index=0&id=494c76d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494c76d0",
  null
  
)

export default component.exports